import { useSelector, useDispatch } from "react-redux";
import { DEFAULT_POLICY_TOPIC, SUCCESS } from "./constants";
import PageIntro from "../../components/PageIntro/component";
import ContentArea from "../../components/ContentArea/async.component";
import classNames from "classnames";
import { getIntroDetails } from "../../utils/pageIntro/library";
import { getShowParams, getPageIntroParams } from "../../utils/path/library";
import { SECTIONS_WITH_BANNERS } from "../../constants/sections";
import { fetchTopicPageData } from "./initData";
import PageAnalytics from "../../components/PageAnalytics";
import { getLandingAnalytics } from "../../utils/analytics/library";
import MaybeError from "../../components/MaybeError/component";
import { TYPE_LANDING } from "../../utils/analytics/constants";
import { PAGE_COMPONENT_UNIVERSAL_CLASS_NAME } from "../../constants/page";

import { SHOWS } from "../../constants/shows";
import { useParams } from "react-router-dom";
import { fetch_topic_load_more } from "../../actions/Topic/dispatchers";
import usePageFetch from "../../hooks/usePageFetch";
import { formatTopicHeading, getTopicHeading } from "./utils";

const Topic = (props) => {
    const {
        statusCode,
        section,
        pageType,
        baseSection,
        subSection,
        path,
        meta,
    } = useSelector((state) => state.app);
    const analytics = useSelector((state) => state.tracking);
    const { kind, keywords } = useParams();
    const dispatch = useDispatch();
    const fetchData = () =>
        dispatch(fetchTopicPageData(props.match.url, props.match.params));

    usePageFetch(props.match, fetchData);

    const content = useSelector((state) => state.content);

    const isTopicPage = pageType === "topic";
    const contentList = content.list;
    const contentStatus = content.status;

    // The topic page name is whatever appears after the last slash in the URL
    const topicHeading = getTopicHeading(path);

    // Banner - this is needed to read from shows config for banners
    const showParams = getShowParams(
        SHOWS,
        baseSection,
        subSection.trim(),
        section
    );
    let pageIntroProps = showParams
        ? getIntroDetails(path, showParams.config)
        : {};

    if (JSON.stringify(pageIntroProps) === "{}") {
        const sectionConfig = getPageIntroParams(
            SECTIONS_WITH_BANNERS,
            path,
            baseSection,
            subSection.trim()
        );
        pageIntroProps = getIntroDetails(path, sectionConfig);
    }

    const classes = classNames("show", PAGE_COMPONENT_UNIVERSAL_CLASS_NAME, {
        topicPage: isTopicPage,
    });

    const listHeading = formatTopicHeading(topicHeading);

    const contentProps = {
        content: contentList,
        hasFeature: false,
        density: DEFAULT_POLICY_TOPIC,
        viewport: props.viewport,
        listHeading: listHeading,
        className: "showContent",
        contentPackage: content.contentPackage,
        loadMore: content.hasNextPage ?? false,
        loadMoreFetch: fetch_topic_load_more(kind, keywords),
    };

    const analyticsProps = getLandingAnalytics({ meta, analytics });

    const getStatusCode = () => {
        // Display 404 Error if number of stories for topic is less than 5
        if (contentStatus === SUCCESS && contentList.length < 5) return 404;
        return statusCode;
    };

    return (
        <MaybeError statusCode={getStatusCode()}>
            <div className={classes} data-testid="topic">
                <PageIntro {...pageIntroProps} />
                <ContentArea {...contentProps} />
                <PageAnalytics dtmData={analyticsProps} type={TYPE_LANDING} />
            </div>
        </MaybeError>
    );
};

export default Topic;
